import { z } from 'zod';
import { UserRole } from '../constants/session.constants';

export const SdpOfferPayloadSchema = z.object({
  type: z.literal('offer'),
  sdp: z.string().min(10, 'SDP inválido')
});

export const SdpAnswerPayloadSchema = z.object({
  type: z.literal('answer'),
  sdp: z.string().min(10, 'SDP inválido')
});

export const IceCandidatePayloadSchema = z.object({
  candidate: z.string().min(1, 'Candidate requerido'),
  sdpMid: z.string().nullable().optional(),
  sdpMLineIndex: z.number().nullable().optional(),
  usernameFragment: z.string().nullable().optional()
});

export const JoinRoomPayloadSchema = z.object({
  sessionId: z.string().uuid(),
  token: z.string().min(10),
  role: z.nativeEnum(UserRole),
  clientMetadata: z.object({
    userAgent: z.string().max(300).optional(),
    hasCamera: z.boolean().optional(),
    hasMic: z.boolean().optional(),
    hasGeolocation: z.boolean().optional()
  }).optional()
});

export const CallEndedPayloadSchema = z.object({
  reason: z.string().optional(),
  notes: z.string().optional(),
  endedByRole: z.nativeEnum(UserRole).optional()
});

export type SdpOfferPayload = z.infer<typeof SdpOfferPayloadSchema>;
export type SdpAnswerPayload = z.infer<typeof SdpAnswerPayloadSchema>;
export type IceCandidatePayload = z.infer<typeof IceCandidatePayloadSchema>;
export type JoinRoomPayload = z.infer<typeof JoinRoomPayloadSchema>;
export type CallEndedPayload = z.infer<typeof CallEndedPayloadSchema>;
